import ADB from "../../../../libs/MediaSDK";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
import { akamai } from "../../../globals";
const { PLAY, PLAYING, QUALITY_CHANGE, DESTROY } = akamai.amp.Events;
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { parseFloat, Number, isNaN, Math, clearInterval } = window;
class QoE {
  constructor(amp, tracker) {
    this.amp = amp;
    this.isVideo = amp.mediaElement.tagName === "VIDEO";
    this.tracker = tracker;
    this.subscriptions = [];
    const { quality, qualityLevels } = amp;
    const qualityLevel = qualityLevels[quality];

    this.bitrateTracking = {
      playTime: 0,
      playingTime: 0,
      bitrate: qualityLevel != null ? qualityLevel.bitrate : 0
    };

    this.timerInterval = null;
    this._fpsTracking = null;
    //this.fpsTracking = this.createFpsTracking();
    //debug.log("[MediaAnalyticsTracking][QoE][constructor]:", this);
  }

  destroy() {
    clearInterval(this.timerInterval);
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  start() {
    this.destroy();
    const { amp } = this;
    this.isVideo = amp.mediaElement.tagName === "VIDEO";
    this.bitrateTracking.playTime = new Date().getTime();
    const qualitychange$ = amp.AmpEventsSources[QUALITY_CHANGE].subscribe(
      (data) => {
        this.onQualityChange(data);
      }
    );

    const play$ = amp.AmpEventsSources[PLAY].subscribe( data => {
      this.bitrateTracking.playTime = new Date().getTime();
      play$.unsubscribe();
    })
    const playing$ = amp.AmpEventsSources[PLAYING].subscribe( data => {
      this.bitrateTracking.playingTime = new Date().getTime();
      playing$.unsubscribe();
      play$.unsubscribe();
    })

    if (this.isVideo) {
      this.timerInterval = setInterval(() => {
        const { fpsTracking } = this;
        if (amp.playState === akamai.amp.PlayState.PLAYING) {
          this.update(fpsTracking);
        }
      }, 2000);
      const { fpsTracking } = this;

    }
    const destroy$ = amp.AmpEventsSources[DESTROY].subscribe((data) => {
      this.destroy();
    });
    this.subscriptions = [play$, playing$, qualitychange$, destroy$];
  }
  stop() {
    this.destroy();
  }

  update(fpsTracking) {
    const { tracker, bitrateTracking} = this;
    const { bitrate, playTime, playingTime } = bitrateTracking;
    const { vpq, fps } = fpsTracking;
    
    let startupTime = Number(
      parseFloat((playingTime - playTime) / 1000).toFixed(4)
    );
    if(startupTime < 0) {
      startupTime = 0;
    }

    const qoeObject = ADB.Media.createQoEObject(
      bitrate,
      startupTime,
      fps,
      vpq.droppedVideoFrames
    );

    debug.log(
      "[MediaAnalyticsTracking][QoE][update] \n\tqoeObject:",
      qoeObject
    );

    tracker.updateQoEObject(qoeObject);
  }

  onQualityChanging(data) {
    //this.bitrateTracking.changingTime = new Date().getTime();
    //debug.log("[MediaAnalyticsTracking][QoE][onQualityChanging] data:", data);
  }
  onQualityChange(data) {

    this.bitrateTracking.bitrate = data.event.data.bitrate;
    const { fpsTracking } = this;

    this.update(fpsTracking);
    this.track();
    //this.fpsTracking = fpsTracking;
    debug.log("[MediaAnalyticsTracking][QoE][onQualityChange] data:", data);
  }
  
  track() {
    const { tracker } = this;
    const stateName = ADB_MEDIA_EVENTS.BitrateChange;
    debug.log("[MediaAnalyticsTracking][QoE][track] \n\tstateName:", stateName);
    tracker.trackEvent(stateName);
  }

  get fpsTracking() {
    const { amp, _fpsTracking: prevFpsTracking } = this;
    const startTime = new Date().getTime();
    
    const vpq =
      this.isVideo && amp.mediaElement.getVideoPlaybackQuality
        ? amp.mediaElement.getVideoPlaybackQuality()
        : { droppedVideoFrame: 0, totalVideoFrames: 0, creationTime: 0 };
    const _totalVideoFrames = prevFpsTracking
      ? prevFpsTracking.vpq.totalVideoFrames
      : 0;
    const _startTime = prevFpsTracking ? prevFpsTracking.startTime : 0;
    const { totalVideoFrames } = vpq;

    const newFrames = totalVideoFrames - _totalVideoFrames;
    const timeDiff = (startTime - _startTime) / 1000;

    let fps = prevFpsTracking ? newFrames / timeDiff : 0;
    if (isNaN(fps) || fps < 0) {
      fps = 0;
    } else {
      fps = Math.round(fps);
    }
    let fpsTracking = {
      startTime,
      fps,
      vpq,
    };
    this._fpsTracking = fpsTracking;

    return fpsTracking;
  }
}

export default QoE;
